import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { GkclLogo } from 'components/atoms/SvgrIcons';

const AfterLogo = () => (
	<Stack
		direction="row"
		sx={{
			alignItems: 'center',
		}}
	>
		<Divider
			orientation="vertical"
			flexItem
			sx={{
				alignSelf: 'center',
				borderColor: 'white.shades.12p',
				marginX: 3,
				height: 38,
			}}
		/>
		<Box
			sx={{
				fontSize: (theme) => theme.gkcl?.svgIcon?.size40,
			}}
		>
			<GkclLogo />
		</Box>
		<Typography
			variant="h6"
			sx={{
				ml: 1,
				color: 'white.main',
				fontWeight: 'regular',
			}}
		>
			{getLabelMessage('common:appName')}
		</Typography>
	</Stack>
);

export default AfterLogo;
